import { useEffect, useRef } from 'react'
import { CheckIcon } from '../icons'
import './ClosedFlash.css'

interface Props {
  /** Kapanan masanın adı, "Masa 3". */
  table: string
  onDone: () => void
}

/**
 * Masa ödemeyle kapanınca ekranın ortasında kısa bir onay (1 Kas 2026,
 * kullanıcı). Parçalı Öde'de son pay ödenince pencere anında kapanıyor, masa
 * gidiyordu; kasiyer "oldu mu?" diye kalıyordu.
 *
 * Kısa ve engellemeyen: dokunuşları arkaya geçiriyor, kasiyer beklemeden bir
 * sonraki işe geçebilir.
 */
export function ClosedFlash({ table, onDone }: Props) {
  // Ref: sayfa her çizildiğinde yeni bir onDone geliyor, sayaç ona bağlı
  // olsaydı kasa ekranı yenilendikçe baştan başlardı.
  const done = useRef(onDone)
  done.current = onDone
  useEffect(() => {
    const t = window.setTimeout(() => done.current(), 1300)
    return () => window.clearTimeout(t)
  }, [])

  return (
    <div className="closedflash" role="status" aria-live="polite">
      <div className="closedflash__card">
        <span className="closedflash__check" aria-hidden="true">
          <CheckIcon />
        </span>
        <strong className="closedflash__table">{table}</strong>
        <span className="closedflash__text">Adisyon kapatıldı</span>
      </div>
    </div>
  )
}
